import { render } from "./AuthorInput.vue?vue&type=template&id=394888ef&scoped=true&ts=true"
import script from "./AuthorInput.vue?vue&type=script&lang=ts"
export * from "./AuthorInput.vue?vue&type=script&lang=ts"

import "./AuthorInput.vue?vue&type=style&index=0&id=394888ef&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394888ef"]])

export default __exports__